import React, { FC } from 'react';
import { Categories } from './categories/Categories';

import { searchConstants } from '../../search-utils/searchConstants';
import { CommonSection } from './CommonSection';
import { CategoryEnum } from '../../search.types';

type Props = {
  type: CategoryEnum;
};

export const AsideFiltersCategory: FC<Props> = ({ type }) => {
  return (
    <CommonSection title={searchConstants.filters[type]}>
      <Categories type={type} />
    </CommonSection>
  );
};
